<template lang="pug">
  div
    span
      | Dashvoard
</template>

<script>
import axios from "../scripts/axios"
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'dashboard',

  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },

  // computed: {
  //   ...mapGetters([
  //   ]),
  // },

  methods: {
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/dashboard.vue